<template>
  <div class="comment-moderation">
    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center">
        <strong>{{ type === 'post' ? 'دیدگاه نوشته‌ها' : 'دیدگاه محصولات' }}</strong>
        <span v-if="selected.length" class="text-nowrap">
          <span class="small text-muted">{{ selected.length }} انتخاب شده</span>
          <CButton size="sm" color="success" variant="outline" @click="setStatus(selected, 1)">تأیید</CButton>
          <CButton size="sm" color="warning" variant="outline" @click="setStatus(selected, 2)">رد</CButton>
        </span>
      </CCardHeader>
      <CCardBody>
        <ServerTable ref="table" :url="api.list" :fields="fields" :tabs="tabs" :default-tab="0" :params="params"
                     search-placeholder="متن، نام یا عنوان" empty-text="دیدگاهی یافت نشد">
          <template #select="{item}"><td><input type="checkbox" :value="item.id" v-model="selected" :aria-label="'انتخاب ' + item.id"></td></template>
          <template #entity_title="{item}"><td class="small" style="max-width:200px">
            <a :href="entityUrl(item)" target="_blank" rel="noopener">{{ item.entity_title || '(حذف شده)' }}</a></td></template>
          <template #body="{item}">
            <td style="min-width:280px">
              <div class="small text-muted mb-1">{{ item.name }} <span v-if="item.customer_mobile" dir="ltr">· {{ item.customer_mobile }}</span>
                <span v-if="item.rate"> · {{ '★'.repeat(item.rate) }}</span> · {{ get_date_time(item.created_at) }}</div>
              <div v-if="item.title"><b>{{ item.title }}</b></div>
              <div class="cm-body">{{ item.body }}</div>
              <div v-for="r in item.replies" :key="r.id" class="cm-reply"><span class="small text-muted">{{ r.admin_id ? 'پاسخ مدیر' : r.name }}:</span> {{ r.body }}</div>
              <div v-if="replyId === item.id" class="mt-2">
                <textarea v-model="replyText" class="form-control form-control-sm" rows="2" placeholder="پاسخ شما…"></textarea>
                <div class="mt-1">
                  <CButton size="sm" color="primary" :disabled="!replyText.trim() || busy" @click="reply(item)"><CSpinner v-if="busy" size="sm"/> ارسال پاسخ</CButton>
                  <CButton size="sm" color="link" @click="replyId = 0">انصراف</CButton>
                </div>
              </div>
            </td>
          </template>
          <template #status="{item}"><td><span :class="['badge', ['badge-warning', 'badge-success', 'badge-danger'][item.status]]">{{ item.status_title }}</span></td></template>
          <template #operation="{item}">
            <td class="text-nowrap">
              <CButton v-if="item.status !== 1" color="success" variant="outline" square size="sm" title="تأیید" @click="setStatus([item.id], 1)"><CIcon name="cil-check" size="sm"/></CButton>
              <CButton v-if="item.status !== 2" color="warning" variant="outline" square size="sm" title="رد" @click="setStatus([item.id], 2)"><CIcon name="cil-x" size="sm"/></CButton>
              <CButton color="primary" variant="outline" square size="sm" title="پاسخ" @click="replyId = item.id; replyText = ''"><CIcon name="cil-share" size="sm"/></CButton>
              <CButton color="danger" variant="outline" square size="sm" title="حذف" @click="remove(item)"><CIcon name="cil-trash" size="sm"/></CButton>
            </td>
          </template>
        </ServerTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from "@/api/http";
import ServerTable from "@/views/includes/ServerTable.vue";
import { confirmAsk, apiToast } from "@/utils/confirm";

const API = {
  post: { list: '/api/admin/blog/blog_comments', status: '/api/admin/blog/change_blog_comment_status', reply: '/api/admin/blog/insert_reply_blog_comment', del: '/api/admin/blog/delete_blog_comment' },
  product: { list: '/api/admin/product/product_comments', status: '/api/admin/product/change_product_comment_status', reply: '/api/admin/product/insert_reply_comment', del: '/api/admin/product/delete_product_comment' },
}

export default {
  name: 'CommentModeration',
  components: { ServerTable },
  props: { type: { type: String, required: true }, entityId: { type: [String, Number], default: '' } },
  data() {
    return {
      selected: [], replyId: 0, replyText: '', busy: false,
      tabs: [{ value: 0, label: 'در انتظار تأیید' }, { value: 1, label: 'تأیید شده' }, { value: 2, label: 'رد شده' }, { value: '', label: 'همه' }],
      fields: [
        { key: 'select', label: '', _style: 'width:32px' },
        { key: 'entity_title', label: this.type === 'post' ? 'نوشته' : 'محصول' },
        { key: 'body', label: 'دیدگاه' },
        { key: 'status', label: 'وضعیت' },
        { key: 'operation', label: 'عملیات' },
      ],
    }
  },
  computed: {
    api() { return API[this.type] },
    params() { return this.entityId ? { entity_id: this.entityId } : {} },
  },
  methods: {
    entityUrl(item) { return String(localStorage.getItem('web_address') || '').replace(/\/+$/, '') + (this.type === 'post' ? '/blog/' : '/product/') + (item.entity_slug || item.entity_id) },
    setStatus(ids, status) {
      axios.post(this.api.status, { ids: ids.join(','), status }).then((res) => {
        apiToast(this, res)
        if (res.data && !res.data.error) {
          ids.forEach((id) => this.$refs.table.patchRow(id, { status, status_title: ['در انتظار تأیید', 'تأیید شده', 'رد شده'][status] }))
          this.selected = []
        }
      }).catch((e) => console.log(e))
    },
    reply(item) {
      if (this.busy) return
      this.busy = true
      axios.post(this.api.reply, { id: item.id, text: this.replyText }).then((res) => {
        apiToast(this, res)
        if (res.data && !res.data.error) {
          this.$refs.table.patchRow(item.id, { status: 1, status_title: 'تأیید شده', replies: item.replies.concat([{ id: Date.now(), admin_id: 1, body: this.replyText }]) })
          this.replyId = 0
        }
      }).catch((e) => console.log(e)).finally(() => { this.busy = false })
    },
    async remove(item) {
      if (!(await confirmAsk(this, 'این دیدگاه و پاسخ‌هایش حذف شود؟'))) return
      axios.post(this.api.del, { id: item.id }).then((res) => {
        apiToast(this, res)
        if (res.data && !res.data.error) this.$refs.table.removeRow(item.id)
      }).catch((e) => console.log(e))
    },
  },
}
</script>

<style scoped>
.cm-body { white-space: pre-line; }
.cm-reply { margin-top: 6px; padding: 6px 10px; background: #f8fafc; border-inline-start: 3px solid var(--accent, #2563eb); border-radius: 4px; font-size: 13px; }
</style>
